import React, { useState, useEffect } from "react";
import { Container, Alert, Table, Button } from "react-bootstrap";
import { ApiGet, ApiPost, ApiPut, ApiDel } from "../../../service/ApiService";
import PropertyModal from "./PropertyModal";

const PropertyManagement = () => {
  const [properties, setProperties] = useState([]);
  const [formValues, setFormValues] = useState({
    name: "",
    value: ""
  });
  // Când se editează, se folosește numele (identificatorul) al parametrului
  const [editingName, setEditingName] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState("");
  const [showModal, setShowModal] = useState(false);

  const fetchProperties = () => {
    ApiGet(
      "/api/property/properties",
      (response) => {
        setError(null);
        setProperties(response || []);
      },
      (err) => {
        setError(err.response?.data?.message || "Eroare la preluarea setărilor.");
        setProperties([]);
      }
    );
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  const handleOpenModalForAdd = () => {
    setEditingName(""); // nu se editează, se adaugă nou
    setFormValues({ name: "", value: "" });
    setShowModal(true);
  };

  const handleOpenModalForEdit = (setare) => {
    setEditingName(setare.name);
    setFormValues({
      name: setare.name,
      value: setare.value
    });
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditingName("");
    setFormValues({ name: "", value: "" });
  };

  const handleSubmit = (values) => {
    // values conține { name, value }
    if (!values.name || !values.value) {
      setError("Introduceți câmpurile necesare (nume și valoare).");
      return;
    }
    if (editingName) {
      // Actualizează parametrul folosind numele ca identificator
      ApiPut(
        `/api/property/properties/${editingName}`,
        values,
        (response) => {
          setSuccess("Setări actualizate cu succes.");
          setError(null);
          handleModalClose();
          fetchProperties();
        },
        (err) => {
          setError(err.response?.data?.message || "Eroare la actualizarea setărilor.");
          setSuccess("");
        }
      );
    } else {
      // Adaugă parametru nou
      ApiPost(
        "/api/property/properties",
        values,
        (response) => {
          setSuccess("Setări adăugate cu succes.");
          setError(null);
          handleModalClose();
          fetchProperties();
        },
        (err) => {
          setError(err.response?.data?.message || "Eroare la adăugarea setărilor.");
          setSuccess("");
        }
      );
    }
  };

  const handleDelete = (setare) => {
    if (window.confirm("Sigur doriți să ștergeți acest parametru?")) {
      ApiDel(
        `/api/property/properties/${setare.name}`,
        (response) => {
          setSuccess("Setări șterse cu succes.");
          setError(null);
          fetchProperties();
        },
        (err) => {
          setError(err.response?.data?.message || "Eroare la ștergerea setărilor.");
          setSuccess("");
        }
      );
    }
  };

  // Funcție utilitară pentru a obfusca valorile pentru parametrii sensibili
  const obfuscateValue = (value) => {
    if (!value || value.length < 2) return value;
    const hiddenLength = value.length - 2;
    return value[0] + "*".repeat(hiddenLength) + value[value.length - 1];
  };

  return (
    <Container fluid className="mt-5">
      <h1>Configurare parametrii</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <Button variant="primary" className="mb-3" onClick={handleOpenModalForAdd}>
        Adaugă parametru
      </Button>

      {/* Tabelul cu parametri (tenantId ascuns) */}
      <Table striped bordered hover responsive className="table-sm">
        <thead>
          <tr>
            <th>Nume</th>
            <th>Valoare</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {properties.length > 0 ? (
            properties.map((setare) => (
              <tr key={setare.name}>
                <td>{setare.name}</td>
                <td>
                  {setare.name.toLowerCase().includes("password")
                    ? obfuscateValue(setare.value)
                    : setare.value}
                </td>
                <td>
                  <Button variant="info" size="sm" onClick={() => handleOpenModalForEdit(setare)}>
                    Modifică
                  </Button>{" "}
                  <Button variant="danger" size="sm" onClick={() => handleDelete(setare)}>
                    Șterge
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">Nu s-au găsit setări.</td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Modalul pentru adăugare/editare */}
      <PropertyModal
        show={showModal}
        handleClose={handleModalClose}
        formValues={formValues}
        onInputChange={(e) =>
          setFormValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
        onSubmit={handleSubmit}
        editing={Boolean(editingName)}
      />
    </Container>
  );
};

export default PropertyManagement;